<template>
  <b-container
    v-if="renderPage"
    class="p-0"
  >
    <b-col
      md="12"
      class="transaction-container p-0"
    >
      <b-card>
        <b-row class="transaction-info-container">
          <b-col
            xl="9"
            lg="12"
            md="12"
            cols="12"
          >
            <p>
              {{ dateTransaction }}, {{ weekDayTransaction }}, {{ hourTransaction }}
            </p>
            <p class="price-text left">
              {{ res.payment.value }}
            </p>
          </b-col>

          <b-col
            xl="3"
            lg="12"
            md="12"
          >
            <div class="status-container">
              <feather-icon
                class="status-item"
                size="50"
                :style="`color: ${status.color} !important;`"
                :icon="status.icon"
              />
              <b-alert
                class="status-item text-center"
                :style="`width: ${status.size}rem !important;`"
                :variant="status.variant"
                show
              > {{ status.status }}
              </b-alert>
            </div>
          </b-col>
        </b-row>
        <b-row class="customer-container mt-1 ">
          <b-col
            class=""
            xl="5"
            lg="6"
            md="12"
            sm="12"
            cols="12"
          >
            <h6>Nome:</h6>
            <p>{{ res.customer.name }}</p>
          </b-col>
          <b-col
            xl="5"
            lg="6"
            md="12"
            sm="12"
            cols="12"
          >
            <h6>E-mail:</h6>
            <p>{{ res.customer.email }}</p>
          </b-col>
          <b-col
            xl="2"
            lg="6"
            md="12"
            sm="12"
            cols="12"
          >
            <h6>{{ res.customer.tax_id.length === 14 ? 'CPF' : res.customer.tax_id.length === 18 ? 'CNPJ' : 'Documento' }}:</h6>
            <p>{{ res.customer.tax_id }}</p>
          </b-col>
          <b-col
            xl="5"
            lg="6"
            md="12"
            sm="12"
            cols="12"
          >
            <h6>Telefone:</h6>
            <p>{{ res.customer.phone }}</p>
          </b-col>
          <b-col
            xl="5"
            lg="6"
            md="12"
            sm="12"
            cols="12"
          >
            <h6 for="">
              Vencimento:
            </h6>
            <p>{{ res.payment.expiration_date }}</p>
          </b-col>
          <b-col
            xl="2"
            lg="6"
            md="12"
            sm="12"
            cols="12"
          >
            <h6 for="">
              Nosso Número:
            </h6>
            <p>{{ res.bankslip.number }}</p>
          </b-col>
          <b-col
            xl="5"
            md="12"
            sm="12"
            cols="12"
          >
            <h6 for="">
              Estabelecimento:
            </h6>
            <p class="establishment-text">
              {{ res.user.soft_descriptor }}
            </p>
          </b-col>
          <b-col
            xl="5"
            md="12"
            sm="12"
            cols="12"
          >
            <h6 for="">
              Código de Barras:
            </h6>
            <p>{{ res.bankslip.bar_code }}</p>
          </b-col>

          <b-col
            xl="2"
            md="12"
            sm="12"
            cols="12"
          />
        </b-row>
      </b-card>
    </b-col>
    <!-- progress -->
    <b-row>
      <b-col
        md="12"
        class="mt-1"
      >
        <b-card v-if="showBar">
          <b-row class="text-center progressbar-container p-0">
            <b-col
              class="justify-content-center"
              md="6"
            >
              <feather-icon
                :class="class1"
                size="38"
                icon="CheckSquareIcon"
              />
              <b-alert
                class="alert-size"
                style="width: 8rem !important;"
                show
                :variant="variant1"
              >
                Boleto Gerado
              </b-alert>
            </b-col>
            <b-col md="6">
              <feather-icon
                :class="status. classLastStatus"
                size="38"
                :icon="status.iconLastStatus"
              />
              <b-alert
                :style="`color: ${status.color} !important;`"
                show
                :variant="status.variantLastStatus"
              >
                {{ status.status }}
              </b-alert>
            </b-col>
          </b-row>

          <div class="progress progress-wrapper">
            <div
              role="progressbar"
              aria-valuemin="0"
              aria-valuemax="100"
              aria-valuenow="100"
              class="progress-bar bg-colorBar"
              :style="`width: ${progressBar}%;`"
            />
          </div>
        </b-card>
        <b-card v-if="!showBar">
          <app-timeline>
            <app-timeline-item
              title="Boleto Gerado"
              subtitle="Boleto Gerado com Sucesso"
              icon="CheckSquareIcon"
              variant="primary"
              data-aos="fade-in"
              data-aos-duration="700"
            />
            <app-timeline-item
              v-if="res.bankslip.status === 1 || res.bankslip.status === 13 || res.bankslip.status === 14"
              :title="status.status"
              :subtitle="res.bankslip.status === 1 || res.bankslip.status === 13 ? 'Boleto Pago com Sucesso' : 'Boleto Baixado'"
              :icon="status.iconLastStatus"
              :variant="status.variantLastStatus"
              data-aos="fade-in"
              data-aos-duration="800"
            />
          </app-timeline>
        </b-card>
        <b-row
          v-if="status.code == 11 || 4"
          class="button-controller"
        >
          <b-col
            xl="6"
            lg="6"
            md="6"
            cols="12"
          >
            <b-button
              variant="info"
              target="_blank"
              class="w-100"
              @click="handleCopyLink"
            >
              Link do Boleto
            </b-button>
          </b-col>
          <b-col
            xl="6"
            lg="6"
            md="6"
            cols="12"
          >
            <b-button
              v-b-modal.modal-prevent-closing
              variant="secondary"
              class="w-100"
            >
              Reenvio de email
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-modal
      id="modal-prevent-closing"
      ref="my-modal"
      title="Reenviar Email"
      ok-title="Enviar"
      cancel-title="Cancelar"
      cancel-variant="outline-secondary"
      :ok-disabled="disabledBtnModal"
      @ok="handleResendMail"
    >
      <b-form
        ref="form"
      >
        <validation-observer
          ref="loginForm"
        >
          <validation-provider
            #default="{ errors }"
            name="Email"
            rules="required|email"
          >
            <b-form-group
              label="Email"
              label-for="Email"
            >
              <b-form-input
                id="Email"
                v-model="mail"
                required
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger"> {{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </validation-observer>
      </b-form>
    </b-modal>
  </b-container>
</template>
<script>
import {
  BCard,
  BContainer,
  BAlert,
  BRow,
  BButton,
  BCol,
  BModal,
  BFormGroup,
  BFormInput,
  BForm,
  VBModal,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'

import AOS from 'aos'

import 'aos/dist/aos.css'

import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

import {
  DateTime,
} from 'luxon'

import FeatherIcon from '../../../@core/components/feather-icon/FeatherIcon.vue'
import { getBankSlip, resendEmail } from '@/service/transaction/transaction'

import { callLoading } from '@/service/utilities/utilities'

const { daysWeek } = require('@/information/detailsTransaction')

export default {
  components: {
    AppTimeline,
    AppTimelineItem,
    BAlert,
    BCard,
    BButton,
    BContainer,
    BRow,
    BCol,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormInput,
    BForm,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      required,
      renderPage: false,
      link: '',
      res: {
        payment: {},
        customer: {},
        link: {},
        bankslip: {},
        product: {},
        user: {},
      },
      textStatusProgress: null,
      statusType: {
        1: {
          code: 1,
          status: 'Boleto Pago',
          progressBar: 100,
          color: '#28c76f',
          icon: 'CheckCircleIcon',
          variant: 'success',
          size: 7,
          textLastStatus: 'Boleto Pago',
          iconLastStatus: 'CheckCircleIcon',
          variantLastStatus: 'success',
          classLastStatus: 'progressbar-success-color',
        },
        4: {
          code: 4,
          status: 'Aguardando Pagamento',
          progressBar: 24,
          color: '#',
          icon: 'ClockIcon',
          variant: 'secondary',
          size: 12,
          textLastStatus: 'Boleto Pago',
          iconLastStatus: 'CheckCircleIcon',
          variantLastStatus: 'secondary',
          classLastStatus: '',
        },
        11: {
          code: 11,
          status: 'Aguardando Pagamento',
          progressBar: 24,
          color: '#',
          icon: 'ClockIcon',
          variant: 'secondary',
          size: 12,
          textLastStatus: 'Boleto Pago',
          iconLastStatus: 'CheckCircleIcon',
          variantLastStatus: 'secondary',
          classLastStatus: '',
        },
        13: {
          code: 13,
          status: 'Pago',
          progressBar: 100,
          color: '#28c76f',
          icon: 'CheckCircleIcon',
          variant: 'success',
          size: 4,
          textLastStatus: 'Boleto Pago',
          iconLastStatus: 'CheckCircleIcon',
          variantLastStatus: 'success',
          classLastStatus: 'progressbar-success-color',
        },
        14: {
          code: 14,
          status: 'Baixado',
          progressBar: 100,
          color: '#ea5455',
          icon: 'XCircleIcon',
          variant: 'danger',
          size: 6,
          textLastStatus: 'Boleto Baixado',
          iconLastStatus: 'XCircleIcon',
          variantLastStatus: 'danger',
          classLastStatus: 'progressbar-denied-color',
        },
      },
      hourTransaction: null,
      weekDayTransaction: null,
      dateTransaction: null,
      bankslipLink: null,
      progressBar: 0,
      variant1: 'secondary',
      variant2: 'secondary',
      class1: '',
      class2: '',
      status: {
        icon: 'checkCircleIcon',
      },
      daysWeek: {
        7: 'Domingo',
        1: 'Segunda-Feira',
        2: 'Terça-Feira',
        3: 'Quarta-Feira',
        4: 'Quinta-Feira',
        5: 'Sexta-Feira',
        6: 'Sábado',
      },
      showBar: true,
      disabledBtnModal: false,
      mail: '',
    }
  },
  beforeRouteLeave(to, from, next) {
    this.renderPage = false
    next()
  },

  computed: {
    transactionDate() {
      const { created_at } = this.res.link

      const weekdayTransaction = daysWeek[DateTime.fromISO(created_at).weekday + 1]
      const transactionDate = DateTime.fromISO(created_at).toFormat('dd/MM/yyyy')
      const transactionHours = `${DateTime.fromISO(created_at).toFormat('HH')}h${DateTime.fromISO(created_at).toFormat('mm')}`

      return transactionDate.concat(', ', weekdayTransaction, ', ', transactionHours)
    },

    valueInReal() {
      const formatter = new Intl.NumberFormat('pt-br', {
        style: 'currency',
        currency: 'BRL',
      })
      const { value } = this.data.payment
      return formatter.format(value)
    },
  },
  watch: {
    mail(value) {
      const valid = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})$/
      this.disabledBtnModal = !valid.test(value)
    },
  },

  async mounted() {
    callLoading(true)
    await this.getInfo()
    await (this.status = this.statusType[this.res.bankslip.status])
    this.mail = this.res.customer.email
    this.progressBarFunction()
    this.animationConfig()
    this.handlerSizeScreen()
    window.addEventListener('resize', this.handlerSizeScreen)
    this.dateTransaction = DateTime.fromISO(this.res.bankslip.created_at).toFormat('dd/MM/yyyy')
    this.hourTransaction = `${DateTime.fromISO(this.res.bankslip.created_at).toFormat('HH')}h${DateTime.fromISO(this.res.bankslip.created_at).toFormat('mm')}`
    this.weekDayTransaction = this.daysWeek[DateTime.fromISO(this.res.bankslip.created_at).weekday + 1]
    callLoading(false)
  },
  methods: {
    animationConfig() {
      AOS.init({
        offset: 120,
        delay: 0,
        duration: 1000,
        easing: 'ease-in',
        once: true,
        anchorPlacement: 'top-bottom',
      })
    },
    async getInfo() {
      try {
        const hash = window.location.pathname.split('/')[4]
        const response = await getBankSlip(hash)

        const formatter = new Intl.NumberFormat('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
        if (response.status === 200) {
          this.res = response.data
          const { url } = this.res.bankslip
          const dt = DateTime.fromISO(this.res.payment.expiration_date)
          this.res.payment.expiration_date = dt.toUTC().toFormat('dd/MM/yyyy')
          this.res.payment.value = formatter.format(this.res.payment.value)
          this.bankslipLink = url
          this.renderPage = true
        } else { this.$router.push('/error404') }
      } catch (err) {
        this.$router.push('/error404')
      }
    },
    async progressBarFunction() {
      while (this.progressBar < this.status.progressBar) {
        this.progressBar = this.status.progressBar
        if (this.progressBar >= 24) {
          this.variant1 = 'info'
          this.class1 = 'progressbar-generate-color'
        }
        if (this.progressBar >= 75) {
          this.variant2 = 'success'
          this.class2 = 'progressbar-success-color'
          this.colorStatusIcon = this.status.color
        }
      }
    },
    elem() {
      return window.innerWidth
    },
    handlerSizeScreen() {
      if (this.elem() > 1190) { this.showBar = true } else { this.showBar = false }
    },
    async handleResendMail(event) {
      event.preventDefault()
      const { id } = (this.$route.params)
      this.$nextTick(() => {
        this.$bvModal.hide('modal-prevent-closing')
      })
      try {
        callLoading(true, true)
        const response = await resendEmail(id, 'bankslip', this.mail)
        const { status } = response

        if (status === 200) {
          this.handleEmailResponse(true)
          this.mail = this.res.customer.email
        } else {
          this.handleEmailResponse(false)
        }
      } catch (err) {
        this.handleEmailResponse(false)
      } finally {
        callLoading(false)
      }
    },
    handleEmailResponse(isSuccess) {
      if (isSuccess) {
        this.$swal({
          title: 'Email enviado com sucesso',
          icon: 'success',
          timer: 1400,
          showConfirmButton: false,
          buttonsStyling: false,
        })
      } else {
        this.$swal({
          title: 'Não foi possível enviar o email',
          icon: 'error',
          timer: 1400,
          showConfirmButton: false,
          buttonsStyling: false,
        })
      }
    },

    async handleCopyLink() {
      navigator.clipboard.writeText(this.bankslipLink)
      this.$swal({
        title: 'Link copiado com sucesso',
        icon: 'success',
        timer: 1400,
        showConfirmButton: false,
        buttonsStyling: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
  @import "@core/scss/base/components/info-card.scss";
  @import "@core/scss/base/components/progress-bar.scss";

  .progressbar-container{
    .alert {
      width: 8rem;
    }
  }

  .transaction-container{
    display: block;
    .status-container{
      margin: 0 !important;
    }
  }

  .btn {
    margin-top: 1rem;
  }
</style>
